import type {
	MaterialSymbolVariant,
} from 'components/material-symbols/symbols';

export enum SportType {
	Unknown = '',
	Football = 'football',
	Basketball = 'basketball',
	Futsal = 'futsal',
	Lacrosse = 'lacrosse',
	Padel = 'padel',
	Floorball = 'floorball',
	Volleyball = 'volleyball',
	IceHockey = 'ice_hockey',
	RugbyUnion = 'rugby_union',
	RugbyLeague = 'rugby_league',
	Handball = 'handball',
	Bandy = 'bandy',
	FieldHockey = 'field_hockey',
	Tennis = 'tennis',
	Swimming = 'swimming',
	Budo = 'budo',
	Boxing = 'boxing',
	Taekwondo = 'taekwondo',
	Pickleball = 'pickleball',
	AustralianRulesFootball = 'australian_rules_football',
	Netball = 'netball',
	FlagFootball = 'flag_football',
	Gymnastics = 'gymnastics',
	Airsoft = 'airsoft',
	AmericanFootball = 'american_football',
	Archery = 'archery',
	Athletics = 'athletics',
	Badminton = 'badminton',
	Cheerleading = 'cheerleading',
	Climbing = 'climbing',
	Cricket = 'cricket',
	Dance = 'dance',
	Darts = 'darts',
	Esports = 'esports',
	Fencing = 'fencing',
	Karate = 'karate',
	Rowing = 'rowing',
	SnowSports = 'snow_sports',
	TableTennis = 'table_tennis',
}

export enum SportFeature {
	PlayerStatisticsAverages = 'playerStatisticsAverages',
	PlayerStatisticsMinutesPlayed = 'playerStatisticsMinutesPlayed',
	ShowMinutesPlayedSetting = 'showMinutesPlayedSetting',
}

export interface Sport {
	type: SportType;
	name?: string;
	icon?: MaterialSymbolVariant;
	features?: SportFeature[];
	defaultMatchDuration: number;
	defaultMatchPeriods: number;
	hasMatchModel: boolean;
	hasRatingModel: boolean;
	hideFormatInCompetitionForm?: boolean;
	hideDistributeInMinutesPlayed?: boolean;
	hasDrawing: boolean;
	hasLineup: boolean;
	playerBased?: boolean;
}
